import { Reveal } from "@/components/Reveal";
import { PricingCards } from "@/components/PricingCards";

export const PricingSection = () => (
  <section id="pricing" className="relative mx-auto max-w-7xl scroll-mt-24 px-5 pb-20 pt-14 sm:px-8 lg:pb-28 lg:pt-20" data-testid="pricing-section">
    <div aria-hidden className="pointer-events-none absolute left-1/2 top-0 h-[480px] w-[720px] max-w-[140vw] -translate-x-1/2 rounded-full bg-blue/15 blur-[140px]" />
    <Reveal className="relative grid gap-8 lg:grid-cols-12 lg:items-end">
      <div className="lg:col-span-7">
        <p className="mono-label">Xpattern // Subscriptions</p>
        <h2 className="display mt-5 text-4xl text-white sm:text-5xl lg:text-7xl" data-testid="pricing-headline">
          Simple pricing. <span className="text-cyan-glow">No surprises.</span>
        </h2>
      </div>
      <p className="max-w-md text-base leading-relaxed text-muted lg:col-span-5 lg:pb-2" data-testid="pricing-subcopy">
        Try it free on your own plotter first. Then pick monthly or yearly — every plan includes the full pattern library
        with new vehicles loaded automatically.
      </p>
    </Reveal>
    <div className="relative mt-10 lg:mt-14">
      <PricingCards />
    </div>
  </section>
);
